import React from 'react'
import { pick, findIndex } from 'lodash-es'
import { Button } from '@ow/comps'
import { useTbViewStore, useDetailStore } from '@vt/hooks'
import { CloseIcon, LeftArrowIcon, RightArrowIcon } from '@ow/icons'

const DetailHeader = function ({ title, close, onClickNextOrPrev }) {
  const { tbData, ditto } = useTbViewStore((state) =>
    pick(state, ['tbData', 'ditto'])
  )
  const { currentData } = useDetailStore((state) =>
    pick(state, ['currentData'])
  )

  const currentDataIndex =
    currentData &&
    findIndex(
      tbData,
      (v) => v[ditto.idFiledName] === currentData[ditto.idFiledName]
    )
  return (
    <div
      className="w-full flex items-center h-14 px-4 justify-between text-gray-100 dark:text-dark-200 border-neutral-300 dark:border-darkTheme-900"
      style={{
        fontSize: '1rem',
        fontWeight: 'bold',
        borderBottomWidth: '1px',
        minHeight: '56px',
      }}
    >
      <span className="text-">{title}</span>
      <div className="flex items-center justify-end gap-3">
        {tbData && tbData.length > 0 && (
          <div className="flex items-center gap-3">
            {currentDataIndex > 0 && (
              <Button
                type="secondary"
                style={{ padding: '0.5rem' }}
                opacityType="sm"
                onClick={() => {
                  onClickNextOrPrev({ data: tbData[currentDataIndex - 1] })
                }}
              >
                <LeftArrowIcon fill="currentColor" />
              </Button>
            )}
            {currentDataIndex + 1 < tbData.length && (
              <Button
                type="secondary"
                style={{ padding: '0.5rem' }}
                opacityType="sm"
                onClick={() => {
                  onClickNextOrPrev({ data: tbData[currentDataIndex + 1] })
                }}
              >
                <RightArrowIcon fill="currentColor" />
              </Button>
            )}
          </div>
        )}
        <div className="cursor-pointer z-10" onClick={close}>
          <CloseIcon width={18} height={18} fill="currentColor" />
        </div>
      </div>
    </div>
  )
}
export default DetailHeader
